import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { ModalService } from './modal.service';
import { IconModule } from '../icon/icon.module';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { DeleteConfirmDialogComponent } from './delete-confirm-dialog/delete-confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog.service';
import { AlertDialogService } from './alert-dialog.service';
import { DeleteConfirmDialogService } from './delete-confirm-dialog.service';

@NgModule({
    declarations: [
        ModalComponent,
        ConfirmDialogComponent,
        AlertDialogComponent,
        DeleteConfirmDialogComponent,
    ],
    imports: [
        CommonModule,
        IconModule
    ],
    providers: [
        ModalService,
        ConfirmDialogService,
        AlertDialogService,
        DeleteConfirmDialogService
    ],
    exports: [
        ModalComponent,
        ConfirmDialogComponent,
        AlertDialogComponent,
        DeleteConfirmDialogComponent,
    ]
})
export class ModalModule { }
